import { APP_ROUTES } from './app.routes';
import { DASHBOARD_ROUTES } from './dashboard.routes';
import { FEATURE_ROUTES } from './features.routes';
import { MANAGEMENT_ROUTES } from './management.routes';
import { CAMPAIGN_ROUTES } from './campaign.routes';
import { LEGACY_ROUTES } from './legacy.routes';

export * from './app.routes';
export * from './dashboard.routes';
export * from './features.routes';
export * from './management.routes';
export * from './campaign.routes';
export * from './legacy.routes';

/** Flat merged route map for convenient imports */
export const ROUTES = Object.freeze({
  APP: APP_ROUTES,
  DASHBOARD: DASHBOARD_ROUTES,
  FEATURES: FEATURE_ROUTES,
  MANAGEMENT: MANAGEMENT_ROUTES,
  CAMPAIGN: CAMPAIGN_ROUTES,
  LEGACY: LEGACY_ROUTES,
});

/**
 * @param {string} pathname
 * @param {string} routePrefix
 */
export function pathStartsWithRoute(pathname, routePrefix) {
  if (!pathname || !routePrefix) return false;
  return pathname === routePrefix || pathname.startsWith(`${routePrefix}/`);
}
